import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  loading: "",
  list: [],
  byId: {},
};

const CategoriesSlice = createSlice({
  name: "Categories",
  initialState,
  reducers: {
    recieveCategories(state, action) {
      state.list = action.payload
      state.byId = Object.fromEntries(action.payload.map(c => [c.id, c]));
    },
  },
});

export const {
  recieveCategories
} = CategoriesSlice.actions

export default CategoriesSlice.reducer;
